import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllAlmacenesList = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/almacenes/list`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllAlmacenesListMutation: mutation.mutate,
    };
}